import { useState,useEffect} from "react";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

import { Sheet } from "react-modal-sheet";
import { Box, Grid, TextField, Typography, InputAdornment } from "@mui/material";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import NotificationSheet from "@/components/NotificationSheet";
import EmailIcon from "@mui/icons-material/Email";

import { useThemeMode } from "@/contexts/ThemeContext"; 

const ChangeEmailSheet = ({ open, onClose, loading = false, email }) => {
     const { isDarkMode } = useThemeMode(); 

	const [isOpen, setIsOpen] = useState(false);
	const [notificationTitle, setNotificationTitle] = useState('');
	const [notificationMessage, setNotificationMessage] = useState('');
	const [notificationType, setNotificationType] = useState('warning');

	const [newEmail, setNewEmail] = useState("");
	const [confirmEmail, setConfirmEmail] = useState("");

	const handleModifyEmail = async () => {
		if (!newEmail.length) {
			setNotificationTitle("Email nou");
			setNotificationMessage("Trebuie să introduceți un email nou.");
			setIsOpen(true);
			return;
		}

		if (!confirmEmail.length) {
			setNotificationTitle("Confirmare email");
			setNotificationMessage("Trebuie să confirmați emailul nou.");
			setIsOpen(true);
			return;
		}

		if (newEmail !== confirmEmail) {
			setNotificationTitle("Emailurile nu se potrivesc");
			setNotificationMessage("Emailul nou și confirmarea nu se potrivesc.");
			setIsOpen(true);
			return;
		}

		const resp = await fetchWrapper.post("/api/users/mobile/account", { newEmail, confirmEmail });

		if (resp.success) {
			setNotificationType('success');
			setNotificationTitle("Success!");
			setNotificationMessage("Emailul a fost modificat cu succes.");
			setIsOpen(true);
			setTimeout(() => {
				setIsOpen(false);
				window.location.href = "/";
			}, 2000);
		} else {
			setNotificationType('error');
			setNotificationTitle("Oops");
			setNotificationMessage(resp.error);
			setIsOpen(true);
		}
	};

	return (
		<>
			<Sheet isOpen={open} onClose={onClose} snapPoints={[1]}>
				<Sheet.Container
					className={"sheet-bg " + (isDarkMode ? "dark" : "")}
					style={{
						borderTopLeftRadius: "0",
						borderTopRightRadius: "0",
						height: "100vh",
						maxHeight: "100vh",
						padding: "24px",
						boxSizing: "border-box",
					}}>
					<Sheet.Header />
					<Sheet.Content style={{ display: "flex", flexDirection: "column", height: "100%" }}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "32px" }}>
							<div style={{ display: "flex", alignItems: "center" }}>
								<button onClick={onClose} style={{ background: "none", border: "none", padding: 0, marginRight: 12, cursor: "pointer" }}>
									<ArrowBackIosNewIcon style={{ fontSize: 20, color: isDarkMode ? "#fff" : "#000" }} />
								</button>
								<h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: isDarkMode ? "#fff" : "#000" }}>
									Modificare email
								</h2>
							</div>

							<button
								onClick={handleModifyEmail}
								disabled={loading}
								style={{
									background: "none",
									border: "none",
									color: "#F0A500",
									fontSize: "16px",
									fontWeight: "500",
									cursor: "pointer",
									padding: 0,
								}}>
								{loading ? "Se salvează..." : "Salvează"}
							</button>
						</div>

						<Box className='glass-box' sx={{ flexGrow: 1 }}>
							<Grid container spacing={3}>
								{/* Email actual */}
								<Grid item xs={12}>
									<Typography component='label' sx={{ fontWeight: 500, fontSize: "16px", mb: "10px", display: "block" }}>
										Email actual
									</Typography>
									<TextField
										disabled
										fullWidth
										value={email}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<EmailIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													color: isDarkMode ? "#fff" : "#000",
												},
                                                            "& input.Mui-disabled": {
                                                                 color: isDarkMode ? "#fff" : "#000",
                                                                 WebkitTextFillColor: isDarkMode ? "#fff" : "#000", 
                                                            },
											},
										}}
									/>
								</Grid>

								{/* Email nou */}
								<Grid item xs={12}>
									<Typography component='label' sx={{ fontWeight: 500, fontSize: "16px", mb: "10px", display: "block" }}>
										Introduceți email nou
									</Typography>
									<TextField
										placeholder='Introduceți email nou'
										variant='outlined'
										fullWidth
										type='email'
										value={newEmail}
										onChange={(e) => setNewEmail(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<EmailIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													color: isDarkMode ? "#fff" : "#000",
												},
											},
										}}
									/>
								</Grid>

								{/* Confirmare email nou */}
								<Grid item xs={12}>
									<Typography component='label' sx={{ fontWeight: 500, fontSize: "16px", mb: "10px", display: "block" }}>
										Confirmați email nou
									</Typography>
									<TextField
										placeholder='Confirmați email nou'
										variant='outlined'
										fullWidth
										type='email'
										value={confirmEmail}
										onChange={(e) => setConfirmEmail(e.target.value)}
										InputProps={{
											startAdornment: (
												<InputAdornment position='start'>
													<EmailIcon sx={{ fontSize: 20 }} />
												</InputAdornment>
											),
											sx: {
												"& input": {
													fontSize: "16px",
													padding: "26px 14px",
													lineHeight: "24px",
													color: isDarkMode ? "#fff" : "#000",
												},
											},
										}}
									/>
								</Grid>
							</Grid>
						</Box>
					</Sheet.Content>
				</Sheet.Container>
				<Sheet.Backdrop />
			</Sheet>

			<NotificationSheet
				open={isOpen}
				onClose={() => setIsOpen(false)}
				type={notificationType}
				title={notificationTitle}
				message={notificationMessage}
				confirmText='Închide'
				withCancel={false}
				onConfirm={() => setIsOpen(false)}
				imageUrl={""}
			/>
		</>
	);
};

export default ChangeEmailSheet;
